import React, { useState } from "react";
import Swal from "sweetalert2";
import logo from "../../resource/7.png";
import apiClient from "@/api/client";

const SoloRetreatRegistrationForm = () => {
  const [formData, setFormData] = useState({
    full_name: "",
    last_name: "",
    date_of_birth: "",
    age: 0,
    gender: "",
    address: "",
    city: "",
    postal_code: "",
    mobile_number: "",
    whatsapp_number: "",
    email_address: "",
    is_beginner: false,
    is_experienced: false,
    from_meditation_teacher: false,
    number_of_days: 0,
    arrival_date: "",
    departure_date: "",
    emergency_first_name: "",
    emergency_last_name: "",
    emergency_email: "",
    emergency_relationship: "",
    emergency_mobile_number_1: "",
    emergency_mobile_number_2: "",
    has_schizophrenia_or_manic_depression: null,
    has_chronic_illness: null,
    health_complications: "",
    specific_questions: "",
    pdf_upload: "",
    sign_full_name: "",
    sign_date: ""
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

const numericFields = ["age", "number_of_days"];

const handleInputChange = (e) => {
  const { name, value, type, checked, files } = e.target;

  if (type === "checkbox") {
    // Exclusive meditation level checkboxes
    if (name === "is_beginner" && checked) {
      setFormData(prev => ({
        ...prev,
        is_beginner: true,
        is_experienced: false
      }));
    } else if (name === "is_experienced" && checked) {
      setFormData(prev => ({
        ...prev,
        is_beginner: false,
        is_experienced: true
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: checked
      }));
    }
  } else if (type === "radio") {
    // Radio buttons for yes/no style fields
    let newValue;

    if (name === "meditation_guidance") {
      newValue = value === "yes";
      setFormData(prev => ({ ...prev, from_meditation_teacher: newValue }));
    } else if (name === "mental_health") {
      newValue = value === "yes";
      setFormData(prev => ({ ...prev, has_schizophrenia_or_manic_depression: newValue }));
    } else if (name === "chronic_illness") {
      newValue = value === "yes";
      setFormData(prev => ({ ...prev, has_chronic_illness: newValue }));
    } else {
      newValue = numericFields.includes(name) ? parseInt(value, 10) : value;
      setFormData(prev => ({ ...prev, [name]: newValue }));
    }
  } else if (type === "file") {
    const file = files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setFormData(prev => ({
          ...prev,
          pdf_upload: event.target.result.split(',')[1] 
        }));
      };
      reader.readAsDataURL(file);
    }
  } else {
    // For text, number, select, etc.
    const newValue = type === "checkbox"
      ? checked
      : numericFields.includes(name)
        ? parseInt(value, 10)
        : value;

    setFormData(prev => ({
      ...prev,
      [name]: newValue
    }));
  }
};


  const validateForm = () => {
    const newErrors = {};

    // Required field validations
    if (!formData.full_name) newErrors.full_name = "First Name is required";
    if (!formData.last_name) newErrors.last_name = "Last Name is required";
    if (!formData.date_of_birth) newErrors.date_of_birth = "Date of birth is required";
    if (!formData.age) newErrors.age = "Age is required";
    else if (!/^\d+$/.test(formData.age)) newErrors.age = "Age must be a number";
    if (!formData.gender) newErrors.gender = "Gender is required";
    if (!formData.address) newErrors.address = "Address is required";
    if (!formData.city) newErrors.city = "City is required";
    if (!formData.postal_code) newErrors.postal_code = "Postal code is required";

    // Mobile number validation
    if (!formData.mobile_number) newErrors.mobile_number = "Mobile number is required";
    else if (!/^\+?\d{10,15}$/.test(formData.mobile_number.replace(/\s/g, ''))) {
      newErrors.mobile_number = "Invalid mobile number format";
    }

    // WhatsApp number validation
    if (!formData.whatsapp_number) newErrors.whatsapp_number = "WhatsApp number is required";
    else if (!/^\+?\d{10,15}$/.test(formData.whatsapp_number.replace(/\s/g, ''))) {
      newErrors.whatsapp_number = "Invalid WhatsApp number format";
    }

    // Email validation
    if (!formData.email_address) newErrors.email_address = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email_address)) {
      newErrors.email_address = "Invalid email format";
    }

    // Meditation level validation
    if (!formData.is_beginner && !formData.is_experienced) {
      newErrors.meditation_level = "Please select your meditation level";
    }

    // Retreat dates validation
    if (!formData.number_of_days) newErrors.number_of_days = "Number of days is required";
    else if (!/^\d+$/.test(formData.number_of_days)) newErrors.number_of_days = "Must be a valid number";
    if (!formData.arrival_date) newErrors.arrival_date = "Arrival date is required";
    if (!formData.departure_date) newErrors.departure_date = "Departure date is required";

    // Emergency contact validations
    if (!formData.emergency_first_name) newErrors.emergency_first_name = "Emergency contact first name is required";
    if (!formData.emergency_last_name) newErrors.emergency_last_name = "Emergency contact last name is required";
    if (!formData.emergency_email) newErrors.emergency_email = "Emergency contact email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emergency_email)) {
      newErrors.emergency_email = "Invalid emergency contact email format";
    }
    if (!formData.emergency_relationship) newErrors.emergency_relationship = "Relationship is required";
    if (!formData.emergency_mobile_number_1) newErrors.emergency_mobile_number_1 = "Emergency mobile number is required";

    // Medical history validations
    if (formData.has_schizophrenia_or_manic_depression === null) {
      newErrors.mental_health = "Please answer the mental health question";
    }
    if (formData.has_chronic_illness === null) {
      newErrors.chronic_illness = "Please answer the chronic illness question";
    }

    // Declaration validations
    if (!formData.pdf_upload) newErrors.pdf_upload = "Payment receipt is required";
    if (!formData.sign_full_name) newErrors.sign_full_name = "Signature name is required";
    if (!formData.sign_date) newErrors.sign_date = "Signature date is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    

    if (!validateForm()) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please check the form for errors.",
      });
      return;
    }
    console.log(formData)

    setLoading(true);

    try {
      const response = await apiClient.post('/create-solo-retreat-registrations', formData);

      console.log("Form submitted successfully:", response.data);

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Solo retreat registration submitted successfully!",
      });

      // Reset form
      setFormData({
        full_name: "",
        last_name: "",
        date_of_birth: "",
        age: 0,
        gender: "",
        address: "",
        city: "",
        postal_code: "",
        mobile_number: "",
        whatsapp_number: "",
        email_address: "",
        is_beginner: false,
        is_experienced: false,
        from_meditation_teacher: false,
        number_of_days: 0,
        arrival_date: "",
        departure_date: "",
        emergency_first_name: "",
        emergency_last_name: "",
        emergency_email: "",
        emergency_relationship: "",
        emergency_mobile_number_1: "",
        emergency_mobile_number_2: "",
        has_schizophrenia_or_manic_depression: null,
        has_chronic_illness: null,
        health_complications: "",
        specific_questions: "",
        pdf_upload: "",
        sign_full_name: "",
        sign_date: ""
      });
      setErrors({});
    } catch (error) {
      console.error("Error submitting form:", error);

      let errorMessage = "Something went wrong!";
      if (error.response) {
        errorMessage = error.response.data.message || "An error occurred while submitting the form.";
      } else if (error.request) {
        errorMessage = "No response from the server. Please try again later.";
      }

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-page dark-gold">
      <form onSubmit={handleSubmit}>
        <div className="form-title">
          <img src={logo} alt="Logo" width={200} />
          <div className="details">
            <h1 className="font-second">Bhaddeka Vihari Monastery Center</h1>
            <h2 className="h4">Solo Retreat Registration Form</h2>
          </div>
        </div>

        <p className="font-p mt-6">
          Welcome to Bhaddheka Vihari Monastery Solo Retreats.
        </p>
        <p className="font-p mt-4">
          Use the following form to fill in the Solo retreatant's details
        </p>

        {/* Full Name */}
        <p className="font-p mt-5">Full Name *</p>
        <div className="form-box mt-4">
          <div className="form-item">
            <input
              type="text"
              id="full_name"
              name="full_name"
              value={formData.full_name}
              onChange={handleInputChange}
            />
            <label htmlFor="full_name">First Name</label>
            {errors.full_name && <span className="error">{errors.full_name}</span>}
          </div>
          <div className="form-item">
            <input
              type="text"
              id="last_name"
              name="last_name"
              value={formData.last_name}
              onChange={handleInputChange}
            />
            <label htmlFor="last_name">Last Name</label>
            {errors.last_name && <span className="error">{errors.last_name}</span>}
          </div>
        </div>

        {/* Date of Birth & Age */}
        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="date"
              id="date_of_birth"
              name="date_of_birth"
              value={formData.date_of_birth}
              onChange={handleInputChange}
            />
            <label htmlFor="date_of_birth">Date of birth*</label>
            {errors.date_of_birth && <span className="error">{errors.date_of_birth}</span>}
          </div>
          <div className="form-item">
            <input
              type="number"
              id="age"
              name="age"
              value={formData.age}
              onChange={handleInputChange}
            />
            <label htmlFor="age">Age*</label>
            {errors.age && <span className="error">{errors.age}</span>}
          </div>
        </div>

        {/* Gender */}
        <p className="font-p mt-5">Gender*</p>
        <div className="gender-box">
          <div>
            <input
              type="radio"
              id="male"
              name="gender"
              value="Male"
              checked={formData.gender === "Male"}
              onChange={handleInputChange}
              className="mt-5"
            />
            <label htmlFor="male">Male</label>
          </div>
          <div>
            <input
              type="radio"
              id="female"
              name="gender"
              value="Female"
              checked={formData.gender === "Female"}
              onChange={handleInputChange}
              className="mt-5"
            />
            <label htmlFor="female">Female</label>
          </div>
        </div>
        {errors.gender && <span className="error">{errors.gender}</span>}

        {/* Address */}
        <p className="font-p mt-5">Address*</p>
        <div className="form-box1">
          <div className="form-item">
            <input
              type="text"
              id="address"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
            />
            <label htmlFor="address">Street Address</label>
            {errors.address && <span className="error">{errors.address}</span>}
          </div>
        </div>

        {/* City */}
        <div className="form-box1 mt-5">
          <div className="form-item">
            <input
              type="text"
              id="city"
              name="city"
              value={formData.city}
              onChange={handleInputChange}
            />
            <label htmlFor="city">City</label>
            {errors.city && <span className="error">{errors.city}</span>}
          </div>
        </div>

        {/* Postal Code */}
        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="text"
              id="postal_code"
              name="postal_code"
              value={formData.postal_code}
              onChange={handleInputChange}
            />
            <label htmlFor="postal_code">Postal/Zip Code*</label>
            {errors.postal_code && <span className="error">{errors.postal_code}</span>}
          </div>
        </div>

        {/* Mobile & WhatsApp Numbers */}
        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="tel"
              id="mobile_number"
              name="mobile_number"
              value={formData.mobile_number}
              onChange={handleInputChange}
            />
            <label htmlFor="mobile_number">Mobile Number*</label>
            {errors.mobile_number && <span className="error">{errors.mobile_number}</span>}
          </div>
          <div className="form-item">
            <input
              type="tel"
              id="whatsapp_number"
              name="whatsapp_number"
              value={formData.whatsapp_number}
              onChange={handleInputChange}
            />
            <label htmlFor="whatsapp_number">WhatsApp Number*</label>
            {errors.whatsapp_number && <span className="error">{errors.whatsapp_number}</span>}
          </div>
        </div>

        {/* Email */}
        <div className="form-box1 mt-5">
          <div className="form-item">
            <input
              type="email"
              id="email_address"
              name="email_address"
              value={formData.email_address}
              onChange={handleInputChange}
            />
            <label htmlFor="email_address">Email Address*</label>
            {errors.email_address && <span className="error">{errors.email_address}</span>}
          </div>
        </div>

        {/* Meditation Level */}
        <p className="font-p mt-5">
          Please indicate if the Solo retreatant is a beginner or an experienced meditator*
        </p>
        <div className="selection mt-4">
          <div className="checkbox-box">
            <label htmlFor="is_beginner">Beginner</label>
            <input
              type="checkbox"
              id="is_beginner"
              name="is_beginner"
              className="checkbox"
              checked={formData.is_beginner}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="is_experienced">Experienced</label>
            <input
              type="checkbox"
              id="is_experienced"
              name="is_experienced"
              className="checkbox"
              checked={formData.is_experienced}
              onChange={handleInputChange}
            />
          </div>
        </div>
        {errors.meditation_level && <span className="error">{errors.meditation_level}</span>}

        {/* Meditation Teacher Guidance */}
        <p className="font-p mt-5">Please indicate if you require guidance from meditation teacher*</p>
        <div className="gender-box">
          <div>
            <input
              type="radio"
              id="guidance_yes"
              name="meditation_guidance"
              value="yes"
              checked={formData.from_meditation_teacher === true}
              onChange={handleInputChange}
              className="mt-5"
            />
            <label htmlFor="guidance_yes">Yes</label>
          </div>
          <div>
            <input
              type="radio"
              id="guidance_no"
              name="meditation_guidance"
              value="no"
              checked={formData.from_meditation_teacher === false}
              onChange={handleInputChange}
              className="mt-5"
            />
            <label htmlFor="guidance_no">No</label>
          </div>
        </div>

        {/* Duration */}
        <p className="font-p mt-5">Please indicate the duration you intend to reside at the Monastery*</p>
        <div className="form-item mt-5">
          <label htmlFor="number_of_days" className="font-p">No of Days</label>
          <input
            type="number"
            id="number_of_days"
            name="number_of_days"
            value={formData.number_of_days}
            onChange={handleInputChange}
          />
          {errors.number_of_days && <span className="error">{errors.number_of_days}</span>}
        </div>

        {/* Retreat Dates */}
        <div className="form-box mt-5">
          <div className="form-item">
            <p className="font-p">Retreat Arrival Date*</p>
            <input
              type="date"
              id="arrival_date"
              name="arrival_date"
              value={formData.arrival_date}
              onChange={handleInputChange}
            />
            {errors.arrival_date && <span className="error">{errors.arrival_date}</span>}
          </div>
          <div className="form-item">
            <p className="font-p">Departure Date*</p>
            <input
              type="date"
              id="departure_date"
              name="departure_date"
              value={formData.departure_date}
              onChange={handleInputChange}
            />
            {errors.departure_date && <span className="error">{errors.departure_date}</span>}
          </div>
        </div>

        {/* Emergency Contact */}
        <h1 className="font-second mt-6">Emergency Contact</h1>
        <p className="font-p mt-5">Full Name*</p>
        <div className="form-box mt-4">
          <div className="form-item">
            <input
              type="text"
              id="emergency_first_name"
              name="emergency_first_name"
              value={formData.emergency_first_name}
              onChange={handleInputChange}
            />
            <label htmlFor="emergency_first_name">First Name</label>
            {errors.emergency_first_name && <span className="error">{errors.emergency_first_name}</span>}
          </div>
          <div className="form-item">
            <input
              type="text"
              id="emergency_last_name"
              name="emergency_last_name"
              value={formData.emergency_last_name}
              onChange={handleInputChange}
            />
            <label htmlFor="emergency_last_name">Last Name</label>
            {errors.emergency_last_name && <span className="error">{errors.emergency_last_name}</span>}
          </div>
        </div>

        {/* Emergency Email */}
        <p className="font-p mt-5">Email Address*</p>
        <div className="form-box1 mt-4">
          <div className="form-item">
            <input
              type="email"
              id="emergency_email"
              name="emergency_email"
              value={formData.emergency_email}
              onChange={handleInputChange}
            />
            <label htmlFor="emergency_email">Email Address</label>
            {errors.emergency_email && <span className="error">{errors.emergency_email}</span>}
          </div>
        </div>

        {/* Emergency Relationship */}
        <p className="font-p mt-5">Relationship*</p>
        <div className="form-box mt-4">
          <div className="form-item">
            <input
              type="text"
              id="emergency_relationship"
              name="emergency_relationship"
              value={formData.emergency_relationship}
              onChange={handleInputChange}
            />
            <label htmlFor="emergency_relationship">Relationship</label>
            {errors.emergency_relationship && <span className="error">{errors.emergency_relationship}</span>}
          </div>
        </div>

        {/* Emergency Phone Numbers */}
        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="tel"
              id="emergency_mobile_number_1"
              name="emergency_mobile_number_1"
              value={formData.emergency_mobile_number_1}
              onChange={handleInputChange}
            />
            <label htmlFor="emergency_mobile_number_1">Mobile Number 1*</label>
            {errors.emergency_mobile_number_1 && <span className="error">{errors.emergency_mobile_number_1}</span>}
          </div>
          <div className="form-item">
            <input
              type="tel"
              id="emergency_mobile_number_2"
              name="emergency_mobile_number_2"
              value={formData.emergency_mobile_number_2}
              onChange={handleInputChange}
            />
            <label htmlFor="emergency_mobile_number_2">Mobile Number 2</label>
          </div>
        </div>

        {/* Medical History */}
        <h1 className="font-second mt-6">Medical History*</h1>
        <p className="font-p mt-5">
          Kindly answer the following questions truthfully and accurately. You
          are required to answer all of the following questions.
        </p>

        <p className="font-p mt-4">
          Is there any past or present history of mental disorder or illness
          such as panic attack, anxiety, schizophrenia or manic-depression?*
        </p>
        <div className="gender-box">
          <div>
            <input
              type="radio"
              id="mental_health_yes"
              name="mental_health"
              value="yes"
              checked={formData.has_schizophrenia_or_manic_depression === true}
              onChange={handleInputChange}
              className="mt-5"
            />
            <label htmlFor="mental_health_yes">Yes</label>
          </div>
          <div>
            <input
              type="radio"
              id="mental_health_no"
              name="mental_health"
              value="no"
              checked={formData.has_schizophrenia_or_manic_depression === false}
              onChange={handleInputChange}
              className="mt-5"
            />
            <label htmlFor="mental_health_no">No</label>
          </div>
        </div>
        {errors.mental_health && <span className="error">{errors.mental_health}</span>}

        <p className="font-p mt-4">
          Do you suffer from any contagious diseases like TB and Hepatitis, or
          from any illness that requires constant treatment?*
        </p>
        <div className="gender-box">
          <div>
            <input
              type="radio"
              id="chronic_illness_yes"
              name="chronic_illness"
              value="yes"
              checked={formData.has_chronic_illness === true}
              onChange={handleInputChange}
              className="mt-5"
            />
            <label htmlFor="chronic_illness_yes">Yes</label>
          </div>
          <div>
            <input
              type="radio"
              id="chronic_illness_no"
              name="chronic_illness"
              value="no"
              checked={formData.has_chronic_illness === false}
              onChange={handleInputChange}
              className="mt-5"
            />
            <label htmlFor="chronic_illness_no">No</label>
          </div>
        </div>
        {errors.chronic_illness && <span className="error">{errors.chronic_illness}</span>}

        {/* Health Complications */}
        <p className="font-p mt-5">
          Please state any other current health complications and/or
          restrictions, physical or psychological that may and/or will affect
          you during your retreat
        </p>
        <div className="mt-5">
          <div className="form-item">
            <textarea
              id="health_complications"
              name="health_complications"
              value={formData.health_complications}
              onChange={handleInputChange}
              rows="6"
            />
            <label htmlFor="health_complications"></label>
          </div>
        </div>

        {/* Specific Questions */}
        <p className="font-p mt-5">
          Please write any specific questions or queries you would like to clarify being a Solo Retreatant
        </p>
        <div className="mt-5">
          <div className="form-item">
            <textarea
              id="specific_questions"
              name="specific_questions"
              value={formData.specific_questions}
              onChange={handleInputChange}
              rows="6"
            />
            <label htmlFor="specific_questions"></label>
          </div>
        </div>

        {/* Declaration and Indemnity Clauses */}
        <h1 className="font-second mt-6">Declaration and Indemnity Clauses*</h1>
        <p className="font-p mt-5">
          Please read the following clauses carefully. Should you have any
          questions, please do not hesitate to contact the monastery for
          clarification
        </p>

        <ul className="unorderd-list mt-4 font-p">
          <li>
            I understand that the centre reserves the right to and/or ask me to
            leave should the information, in whole or in part, prove to be
            materially untrue and incorrect.
          </li>
          <li>
            I understand that the centre reserves the right to and/or ask me to
            leave if I don't meet the retreat centre's rules and regulations
            listed here.
          </li>
          <li>
            I shall not hold the centre responsible and/or liable for any mishap
            and untoward occurrences
          </li>
          <li>
            I shall not hold the centre responsible for any physical or mental
            illness that may occur before, during and/or after the retreat
          </li>
          <li>
            I will not hold the centre liable and/or responsible for any items
            lost in its premises
          </li>
          <li>
            You are advised to place your monies, personal valuables and
            traveling documents with the office for safe keeping. Items kept in
            the office is at owner's risk.
          </li>
          <li>
            I understand that the full payment for my retreat application fee
            will not be refunded in the event that I terminate the retreat
            unexpectedly.
          </li>
          <li>
            You are prohibited from taking any illicit drugs, alcohol, smoking or
            vaping during the retreat period. Retreatants are not allowed to go
            out of the Meditation Centre during the retreat unless without
            informing the meditation instructor or Monastery senior abbot.
          </li>
          <li>
            No visitors allowed during the retreat. I understand that the centre
            reserves the right to and/or ask me to leave if I don't meet these
            regulations
          </li>
          <li>
            Please refrain from subjecting any form of bullying or harassments,
            failing to maintain a respectful boundary, creating a threatening
            environment and failing to foster comfort and safety of other fellow
            retreatants or retreat staff members
          </li>
          <li>
            You will be held responsible for any damage to property or buildings
            on the premises of the monastery during the retreat period.
          </li>
          <li>
            I understand that priority will be given to retreatants attending
            the full duration of the retreat program
          </li>
          <li>
            Please inform the office if there is any change in your date of
            departure due to an unexpected event.
          </li>
          <li>
            I undertake to abide strictly by the rules of this centre, to
            practice sincerely and conscientiously, and to follow closely the
            instructions of the meditation teacher.
          </li>
        </ul>

        {/* Payment Upload */}
        <p className="font-p mt-4 color-red">
          Please proceed with the payment of your retreat registration fee of
          $50 here. *
        </p>
        <div className="form-box">
          <div className="form-item">
            <input
              type="file"
              id="pdf_upload"
              name="pdf_upload"
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={handleInputChange}
            />
            <label htmlFor="pdf_upload">Attach payment receipt here</label>
            {errors.pdf_upload && <span className="error">{errors.pdf_upload}</span>}
          </div>
        </div>

        {/* Declaration Signature */}
        <p className="font-p mt-5 pb-4">
          I attest that the information given in this application form is true
          and correct. I understand that the centre reserves the right to reject
          my application.
        </p>

        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="text"
              id="sign_full_name"
              name="sign_full_name"
              value={formData.sign_full_name}
              onChange={handleInputChange}
            />
            <label htmlFor="sign_full_name">Full Name*</label>
            {errors.sign_full_name && <span className="error">{errors.sign_full_name}</span>}
          </div>
        </div>

        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="date"
              id="sign_date"
              name="sign_date"
              value={formData.sign_date}
              onChange={handleInputChange}
            />
            <label htmlFor="sign_date">Sign Date*</label>
            {errors.sign_date && <span className="error">{errors.sign_date}</span>}
          </div>
        </div>



        <button type="submit" id="submitbtn" className="mt-5">
          Submit
        </button>

        <p className="font-p mt-5 pb-4">
          lf you find that you have benefited from the practice, and would like
          to contribute to help us maintain the centre and its meditation
          tradition, we would welcome it.
        </p>

      </form>
    </div>

  )
}

export default SoloRetreatRegistrationForm;